import { createContext } from 'react';

const productoContext = createContext();

export default productoContext;